import { useModalContext } from 'common/Context/ModalContext';
import React from 'react';
import Image from './Image';

interface Props {
  src: string | undefined | null;
  alt: string;
  isLoading?: boolean;
  className?: string;
  testId?: string;
  fallbackUrl?: string;
}

const ProductImage: React.FC<Props> = (props) => {
  const { openModal } = useModalContext();
  const onError = (): void =>
    openModal({
      type: 'BROKEN_IMAGES'
    });

  return <Image {...props} onError={onError} />;
};

export default ProductImage;
